import { render, staticRenderFns } from "./_OnlineFor.vue?vue&type=template&id=01ed189f"
import script from "./_OnlineFor.vue?vue&type=script&lang=ts"
export * from "./_OnlineFor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports